export default __webpack_public_path__ + "static/media/neutral.2b2e10f8.svg";